import { useEffect } from 'react';
import type { KeyboardEvent, RefObject } from 'react';

const items = (menu: HTMLElement | null) =>
    Array.from(menu?.querySelectorAll<HTMLElement>('[role="menuitem"]') ?? []);

export const useMenuKeyboard = (
    open: boolean,
    menuRef: RefObject<HTMLElement | null>,
    triggerRef: RefObject<HTMLElement | null>,
    close: () => void,
) => {
    useEffect(() => {
        if (open) items(menuRef.current)[0]?.focus();
    }, [open, menuRef]);

    return (e: KeyboardEvent<HTMLElement>) => {
        const list = items(menuRef.current);
        const current = list.indexOf(document.activeElement as HTMLElement);
        const focusAt = (index: number) => list[(index + list.length) % list.length]?.focus();

        switch (e.key) {
            case 'ArrowDown': e.preventDefault(); focusAt(current + 1); break;
            case 'ArrowUp': e.preventDefault(); focusAt(current - 1); break;
            case 'Home': e.preventDefault(); focusAt(0); break;
            case 'End': e.preventDefault(); focusAt(list.length - 1); break;
            case 'Escape': triggerRef.current?.focus(); close(); break;
            case 'Tab': close(); break;
        }
    };
};
